module.exports = __webpack_public_path__ + "static/media/dreamcast_logo.2019011d.svg";